/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { featuresProvisionalDetailConfig } from '../../config/featuresSection.config';

export interface IFeatureSectionPluginMethods extends IPluginMethodMap {
  getFeatureSectionSync(args?: any): any;
}

export class FeatureSectionPlugin implements IAgentPlugin {
  readonly methods: IFeatureSectionPluginMethods;

  constructor() {
    this.methods = {
      getFeatureSectionSync: this.getFeatureSectionSync.bind(this),
    };
  }

  getFeatureSectionSync(args?: any) {
    return {
      feature: featuresProvisionalDetailConfig,
    };
  }
}
